import React from 'react';
import cleanLinkSrc from '../../../../utils/xss/cleanLinkSrc';
import { useLazyLoading } from '../../../../LazyLoadingImage/useLazyLoading';
var Img = function (props) {
    var file = props.file, deviation = props.deviation, imgStyles = props.imgStyles;
    var _a = useLazyLoading(true), enableLazyLoading = _a.enableLazyLoading, supportsNativeLazy = _a.supportsNativeLazy;
    var isLazyLoaded = enableLazyLoading && supportsNativeLazy;
    return (React.createElement("img", { loading: isLazyLoaded ? 'lazy' : undefined, src: cleanLinkSrc(file.src), srcSet: file.srcSet, alt: deviation.title, style: imgStyles }));
};
Img.displayName = 'Img';
export default Img;
//# sourceMappingURL=ImageBase.js.map